import type { ReactNode } from 'react';
import { AdminContext, type AdminContextValue } from './adminContext';

/** What generic admin screens need: the resource definitions, the API client and the session. */
export function AdminProvider({ children, ...value }: AdminContextValue & { children: ReactNode }) {
  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}
